/**
 * English - `scheduleSessions`: a person's week split into working sessions
 * (a morning OPD and an evening one), and how patients book with them - a
 * time slot each, or a token number in a session's queue. Used by My
 * schedule and the Our team editor. Conventions: see `common.ts`.
 */
const scheduleSessions: Record<string, string> = {
  'week.intro': 'Split a day into sessions with a break between - a morning OPD and an evening one. Up to {max} sessions a day.',
  'day.off': 'Day off',
  'day.toggle': '{day}: working day',
  'session.from': 'From',
  'session.to': 'to',
  'session.opens': '{day} session {number} starts',
  'session.closes': '{day} session {number} ends',
  'session.add': 'Add session',
  'session.add_label': 'Add a session on {day}',
  'session.remove': 'Remove',
  'session.remove_label': 'Remove {day} session {number}',
  'session.full': 'Up to {max} sessions a day.',
  'error.time': 'On {day}, enter a start and end time for every session.',
  'error.order': 'On {day}, each session must end after it starts.',
  'error.overlap': 'On {day}, the sessions overlap. Start each one after the one before it ends.',

  'mode.legend': 'How patients book with you',
  'mode.legend_other': 'How patients book with them',
  'mode.info': 'Time slots give every appointment its own start time. Tokens run each working session as a queue: patients take the next number and are seen in turn.',
  'mode.slots': 'Time slots',
  'mode.slots_hint': 'Patients pick a time, like 10:30, and each appointment has its own slot.',
  'mode.tokens': 'Token number (OPD queue)',
  'mode.tokens_hint': 'Patients take the next token in a session and are seen in order, numbered from 1 each session.',
  'token_minutes': 'Minutes per patient (for estimated times)',
  'token_minutes.hint': 'Only used to estimate when each token is seen. Leave blank for {value}.',
  'max_tokens': 'Maximum tokens per session',
  'max_tokens.hint': 'Optional. Leave blank for no limit.',
  'slot_hidden': 'Booking by token has no start-time grid, so the appointment interval does not apply.',
};

export default scheduleSessions;
